import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="grain min-h-screen grid lg:grid-cols-2">
      {/* Left: form */}
      <div className="flex items-center justify-center px-6 py-16 lg:py-24 bg-[hsl(var(--background))] relative z-10">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-10">
            <img src="/logo-mark.png" alt="Clara Martínez" className="w-12 h-12 object-contain" />
            <div>
              <div className="font-bold text-neutral-900 tracking-tight text-lg">Clara Martínez</div>
              <div className="overline">Psicóloga · Origen</div>
            </div>
          </div>

          <div className="overline mb-3">Bienvenido</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-neutral-900 mb-3">
            Ingresá a tu <span className="text-[hsl(var(--sage-hover))]">consultorio</span>
          </h1>
          <p className="text-neutral-500 mb-10">
            Gestioná pacientes, agenda, tratamientos y libro de caja en un solo lugar.
          </p>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="block text-sm font-medium text-neutral-700 mb-1.5">
                Email
              </label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-clinic"
                placeholder="admin@consultorio.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-neutral-700 mb-1.5">
                Contraseña
              </label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-clinic"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div
                data-testid="login-error"
                className="text-sm text-[hsl(var(--terracotta))] bg-[hsl(var(--terracotta))]/10 rounded-lg px-3.5 py-2.5 border border-[hsl(var(--terracotta))]/20"
              >
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="btn-primary-pill w-full disabled:opacity-70"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Ingresando…
                </>
              ) : (
                "Ingresar"
              )}
            </button>
          </form>
        </div>
      </div>

      {/* Right: image panel */}
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1774612541935-14b5efc16511?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwcHN5Y2hvbG9neSUyMGNsaW5pYyUyMHdhcm0lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQxNzA0NTN8MA&ixlib=rb-4.1.0&q=85"
          alt="Consultorio cálido"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-neutral-900/25" />
        <div className="absolute inset-0 flex flex-col justify-end p-14">
          <div className="overline text-white/80 mb-3">Espacio seguro · Origen</div>
          <p className="text-white text-3xl font-semibold leading-tight max-w-md tracking-tight">
            Un espacio para acompañar cada consulta con claridad y calma.
          </p>
        </div>
      </div>
    </div>
  );
}
